module.exports = __webpack_public_path__ + "img/del-icon.7ab5b1dc.png";